export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Объект комментария
  //--------------------------------------------------------------------------
  comment: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                        Контекст комментариев
  //--------------------------------------------------------------------------
  commentsPlace: {
    type: String,
    required: true
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
